import { z } from "zod";

export const REFUND_SCHEMA = z
  .object({
    amount: z.number().min(1, "Amount is required"),
    reason: z.string().min(1, "Reason is required"),
  })
  .refine((data) => {
    if (!data.amount) {
      return false;
    }
    if (!data.reason || data.reason.trim() === "") {
      return false;
    }

    return true;
  });

export type RefundFormData = z.infer<typeof REFUND_SCHEMA>;
